import React from "react";

import EditIcon from "material-ui-icons/Edit";
import SaveIcon from "material-ui-icons/Save";
import CloseIcon from "material-ui-icons/Close";
import renderTextfield from "../form/RenderTextField";
import Input, { InputAdornment, InputProps } from "material-ui/Input";

interface EditableHeaderProps {
    headerType: "h1" | "h2" | "h3" | "h4";
    value: string;
    maxLength?: number;
    saveValue: (value: string) => void;
    label?: string;
    isVisible?: boolean;
}

interface EditableHeaderState {
    editing: boolean;
}

export class EditableHeader extends React.Component<
    EditableHeaderProps,
    EditableHeaderState
> {
    constructor(props: EditableHeaderProps) {
        super(props);

        this.state = {
            editing: false,
        };
    }

    input: HTMLInputElement;

    renderInput = () => {
        return (
            <Input
                inputProps={{
                    maxLength: this.props.maxLength,
                    "aria-label": this.props.label,
                }}
                inputRef={(c) => (this.input = c!)}
                defaultValue={this.props.value}
                style={{ fontSize: "1.35em", width: "calc(100% - 58px)" }}
                classes={{
                    error: "hypo-error",
                    focused: "hypoblue",
                    disabled: "hypo-disabled",
                    root: "hypoblue",
                    underline: "hypoblue-underline",
                    input: "hypoblue",
                }}
                type={"text"}
            />
        );
    };

    editClick = () => {
        this.setState({
            editing: true,
        });
    };

    saveClick = () => {
        this.setState({
            editing: false,
        });

        this.props.saveValue(this.input.value);
    };

    cancelClick = () => {
        this.setState({
            editing: false,
        });
    };

    renderHeader = (value: string, type: "h1" | "h2" | "h3" | "h4") => {
        const editIcon = (
            <EditIcon
                style={{
                    width: 16,
                    height: 16,
                    marginLeft: 5,
                    fill: "#3a649e",
                }}
            />
        );

        return (
            (type === "h1" && (
                <div
                    tabIndex={!this.props.isVisible ? -1 : 0}
                    style={{ width: "100%" }}
                    onClick={this.editClick}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.setState({
                                editing: true,
                            });
                        }
                    }}
                    className={"gridItem"}
                >
                    <h1
                        style={{
                            maxWidth: "calc(100% - 21px)",
                            display: "inline-block",
                            wordBreak: "break-word",
                        }}
                        className={`hypoblue no-margin`}
                    >
                        {value}
                    </h1>
                    {editIcon}
                </div>
            )) ||
            (type === "h2" && (
                <div
                    tabIndex={!this.props.isVisible ? -1 : 0}
                    style={{ width: "100%" }}
                    onClick={this.editClick}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.setState({
                                editing: true,
                            });
                        }
                    }}
                    className={"gridItem"}
                >
                    <h2
                        style={{
                            maxWidth: "calc(100% - 21px)",
                            display: "inline-block",
                            wordBreak: "break-word",
                        }}
                        className={`hypoblue no-margin`}
                    >
                        {value}
                    </h2>
                    {editIcon}
                </div>
            )) ||
            (type === "h3" && (
                <div
                    tabIndex={!this.props.isVisible ? -1 : 0}
                    style={{ width: "100%" }}
                    onClick={this.editClick}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.setState({
                                editing: true,
                            });
                        }
                    }}
                    className={"gridItem"}
                >
                    <h3
                        style={{
                            maxWidth: "calc(100% - 21px)",
                            display: "inline-block",
                            wordBreak: "break-word",
                        }}
                        className={`hypoblue no-margin`}
                    >
                        {value}
                    </h3>
                    {editIcon}
                </div>
            )) ||
            (type === "h4" && (
                <div
                    tabIndex={!this.props.isVisible ? -1 : 0}
                    style={{ width: "100%" }}
                    onClick={this.editClick}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.setState({
                                editing: true,
                            });
                        }
                    }}
                    className={"gridItem"}
                >
                    <h4
                        style={{
                            maxWidth: "calc(100% - 21px)",
                            display: "inline-block",
                            wordBreak: "break-word",
                        }}
                        className={`hypoblue no-margin`}
                    >
                        {value}
                    </h4>
                    {editIcon}
                </div>
            ))
        );
    };

    renderEditableHeader = (value: string) => {
        return (
            <div style={{ height: "100%" }}>
                {this.renderInput()}
                <div
                    style={{
                        height: "100%",
                        display: "inline-block",
                        verticalAlign: "bottom",
                    }}
                >
                    <SaveIcon
                        style={{
                            width: 24,
                            height: 24,
                            marginLeft: 5,
                            color: "#3a649e",
                        }}
                        titleAccess={"Tallenna nimi"}
                        tabIndex={!this.props.isVisible ? -1 : 0}
                        onClick={this.saveClick}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                this.setState({
                                    editing: false,
                                });

                                this.props.saveValue(this.input.value);
                            }
                        }}
                    />
                    <CloseIcon
                        style={{
                            width: 24,
                            height: 24,
                            marginLeft: 5,
                            color: "red",
                        }}
                        titleAccess={"Peruuta"}
                        tabIndex={!this.props.isVisible ? -1 : 0}
                        onClick={this.cancelClick}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                this.setState({
                                    editing: false,
                                });
                            }
                        }}
                    />
                </div>
            </div>
        );
    };

    render() {
        const editing = this.state.editing;
        const value = this.props.value;
        const type = this.props.headerType;

        const content = editing
            ? this.renderEditableHeader(value)
            : this.renderHeader(value, type);

        return content;
    }
}



// WEBPACK FOOTER //
// ./src/components/EditableHeader/EditableHeader.tsx